///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthHistoryService } from '../../../engine/history-service';
import { E2eTestUtils } from '../../../../../../testing/e2e-test-utils';
import { TestMarkerView } from '../../marker/test/test-marker-view';

export class PolygonFeatureView {
    private polygon: google.maps.Polygon;
    private readonly polygonColor = '#4a90e2';
    private readonly polygonColorSelected = '#49e260';
    private readonly polygonOptions: google.maps.PolygonOptions = {
        paths: this.polygonPath,
        strokeColor: this.polygonColor,
        clickable: true,
        zIndex: 1,
        fillOpacity: 0,
        strokeWeight: 2,
        strokePosition: 1,
        fillColor: 'rgba(255,255,255,0)'
    };

    private testMarker: TestMarkerView;

    constructor(
        private readonly historyService: GtthHistoryService,
        private readonly polygonIndex: number,
        private readonly polygonPath: google.maps.LatLngLiteral[]
    ) {}

    draw(): void {
        if (this.polygon) {
            return;
        }

        this.polygon = new google.maps.Polygon(this.polygonOptions);
        this.polygon.setMap(this.historyService.map);

        if (E2eTestUtils.getShowPolygonMarkers()) {
            const bounds = new google.maps.LatLngBounds();

            this.polygonPath.forEach((point) => {
                bounds.extend(point);
            });

            this.testMarker = new TestMarkerView(
                bounds.getCenter().toJSON(),
                `${E2eTestUtils.getShowPolygonMarkers()} polygon ${this.polygonIndex}`
            );
            this.testMarker.draw(this.historyService.map);
        }
    }

    restoreDefaultOptions() {
        this.polygon.setOptions(this.polygonOptions);
    }

    setOptions(options: google.maps.PolygonOptions) {
        this.polygon.setOptions(options);
    }

    select() {
        this.polygon.setOptions({ strokeColor: this.polygonColorSelected });
    }

    unselect() {
        this.polygon.setOptions({ strokeColor: this.polygonColor });
    }

    hide() {
        if (this.polygon) {
            this.destroyListeners();
            this.polygon.setMap(null);
            this.polygon = null;
        }

        if (this.testMarker) {
            this.testMarker.hide();
            this.testMarker = undefined;
        }
    }

    registerRightClickListener(callback: (event: google.maps.MapMouseEvent) => any) {
        this.polygon?.addListener('rightclick', callback);

        this.polygon?.addListener('click', (mouseEvent) => {
            google.maps.event.trigger(this.historyService.map, 'click', mouseEvent);
        });

        this.testMarker?.registerRightClickListener(callback);
    }

    destroyListeners() {
        google.maps.event.clearInstanceListeners(this.polygon);
    }
}
